import { css } from '@emotion/react'
import { useTranslation } from 'next-i18next'

import { mediaUp } from '@/styles/media'
import { Text2Styles } from '@/styles/typography'
import { colors, weights } from '@/styles/theme'

import Modal from '../common/Modal'

interface Props {
  onCancel: () => void
}

function ManualOperationModal(props: Props) {
  const { onCancel } = props

  const { t } = useTranslation('common')

  return (
    <Modal show={true} onClose={onCancel}>
      <>
        <h2 css={style.title}>{t('manualOperation')}</h2>
        <h2 css={style.paragraph}>{t('modal.manualOparationParagraph')}</h2>
        <h2 css={style.paragraph}>{t('modal.manualOparationDisclaimer')}</h2>
      </>
    </Modal>
  )
}

const style = {
  title: css`
    font-weight: ${weights.black};
    font-size: 24px;
    color: ${colors.twilightBlue};
  `,

  paragraph: css`
    margin-top: 16px;
    ${Text2Styles};
    color: ${colors.twilightBlue};

    ${mediaUp('lg')} {
      margin-top: 33px;
    }
  `
}

export default ManualOperationModal
